var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFont5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.4 500",
    style: {
      enableBackground: "new 0 0 330.4 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#010101;stroke-width:25;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "60.8,465.0 158.299,81.645 165.314,58.731 169.511,47.526 171.136,43.873 172.947,40.323 175.047,36.946 177.607,33.946 180.941,31.81 184.874,31.433 188.613,32.77 191.867,35.082 194.708,37.869 197.262,40.929 201.791,47.511 205.789,54.424 212.834,68.773 249.838,165.83 259.694,196.221 273.742,250.346 286.298,313.01 292.415,352.462 296.538,392.208 297.594,412.174 297.579,424.16 297.089,432.161 296.617,436.127 295.915,440.059 294.849,443.969 292.564,447.032 289.655,444.929 287.569,441.409 284.466,434.446 279.074,419.449 186.1,46.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16.4,295.3 194.128,292.992 245.595,290.02 268.862,287.546 288.443,284.418 307.603,280.097 311.4,279.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "71.7,84.4 86.732,247.512 92.078,391.155 92.011,419.121 91.452,431.089 91.078,435.084 90.5,438.983 89.058,442.597 87.068,439.509 86.164,435.661 84.937,427.754 76.082,292.177 70.645,244.561 65.411,213.062 59.31,185.809 41.076,116.282 37.751,100.661 36.027,88.808 35.413,80.845 35.347,72.86 35.967,64.898 36.591,60.952 37.461,57.056 38.607,53.236 40.066,49.515 41.864,45.952 44.022,42.596 46.543,39.502 49.379,36.695 52.481,34.177 55.79,31.947 59.268,29.989 62.883,28.289 66.603,26.831 70.402,25.604 74.264,24.593 78.176,23.787 86.096,22.765 94.074,22.471 102.05,22.837 109.979,23.798 117.822,25.293 125.559,27.273 133.17,29.692 144.331,34.037 155.185,39.103 169.214,46.726 182.782,55.142 195.88,64.293 208.481,74.13 220.513,84.665 229.056,93.045 237.122,101.873 244.63,111.206 249.222,117.739 253.396,124.547 257.058,131.643 260.102,139.023 262.425,146.663 263.29,150.562 263.943,154.501 264.372,158.47 264.564,162.459 264.504,166.452 264.177,170.432 263.569,174.377 262.666,178.266 261.46,182.072 259.956,185.756 258.166,189.316 256.103,192.734 253.786,195.992 251.231,199.069 248.452,201.948 245.467,204.61 242.292,207.037 238.944,209.209 235.437,211.107 231.784,212.719 228.018,214.042 224.167,215.093 220.254,215.89 216.299,216.453 208.333,216.961 200.35,216.771 192.399,216.012 184.509,214.784 172.813,212.199 161.303,208.881 127.534,196.562 123.689,195.399 119.766,194.654 116.243,195.854 116.63,199.729 118.392,203.31 120.557,206.675 125.456,212.979 130.846,218.883 139.563,227.099 179.649,260.085 200.296,278.919 219.865,298.879 238.394,319.825 250.825,335.45 260.033,348.474 266.385,358.63 272.094,369.161 275.449,376.407 278.37,383.838 280.785,391.452 282.577,399.234 283.183,403.178 283.557,407.156 283.66,411.151 283.449,415.136 282.876,419.083 281.892,422.954 280.459,426.677 278.563,430.188 276.257,433.443 273.612,436.435 270.696,439.166 267.571,441.645 264.273,443.896 260.837,445.935 257.29,447.777 249.951,450.92 242.364,453.41 234.606,455.302 226.736,456.651 218.798,457.517 206.83,458.034 194.885,457.774 178.985,456.484 143.39,451.225 49.415,432.55 21.8,428.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "266.0,95.5 249.16,84.819 235.266,77.051 224.493,71.848 217.159,68.793 209.631,66.119 202.007,63.921 194.232,62.211 186.365,60.965 178.445,60.147 170.493,59.798 162.537,59.957 154.599,60.639 146.727,61.826 138.936,63.473 131.247,65.546 123.689,68.057 116.297,71.019 109.107,74.443 102.162,78.339 95.501,82.704 89.142,87.497 83.086,92.669 77.333,98.177 69.26,106.981 61.842,116.342 55.093,126.196 49.032,136.49 43.684,147.173 39.068,158.182 35.189,169.477 32.054,181.01 29.67,192.719 27.992,204.546 26.671,220.418 26.14,240.321 26.534,256.244 27.841,272.118 29.541,283.942 31.946,295.643 35.132,307.155 37.726,314.685 40.714,322.067 45.91,332.822 51.848,343.187 58.405,353.172 67.943,365.938 75.644,375.076 83.814,383.784 92.457,392.019 101.572,399.746 111.118,406.932 121.055,413.557 131.358,419.608 142.002,425.048 152.95,429.812 164.185,433.845 175.678,437.095 187.366,439.56 199.188,441.28 211.09,442.294 223.032,442.628 234.971,442.247 246.86,441.093 258.638,439.105 270.232,436.241 281.586,432.556 296.357,426.613 310.748,419.8 321.175,414.018 331.234,407.595 344.134,398.183 359.424,385.541 371.3,374.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "88.5,66.3 70.255,385.584 66.202,425.41 64.476,437.281 62.905,445.079 61.709,448.985 59.358,451.731 56.728,449.067 55.713,445.238 55.141,441.23 54.231,425.33 53.078,241.457 47.39,125.69 47.268,109.715 47.757,97.747 48.941,85.817 50.247,77.933 52.107,70.163 53.289,66.344 54.662,62.591 56.245,58.923 58.052,55.361 60.099,51.93 62.389,48.655 64.906,45.552 67.635,42.634 70.559,39.91 73.661,37.391 76.925,35.087 80.337,33.006 83.88,31.158 87.538,29.551 91.297,28.195 95.139,27.099 99.047,26.262 103.0,25.677 106.98,25.332 110.974,25.217 114.969,25.32 122.918,26.138 130.752,27.708 138.416,29.968 145.865,32.86 153.076,36.302 160.041,40.219 166.765,44.539 176.422,51.641 185.602,59.365 194.27,67.657 202.375,76.482 209.872,85.815 216.748,95.634 223.013,105.853 228.704,116.403 235.481,130.877 242.833,149.453 251.559,176.023 258.857,203.025 263.956,226.468 267.152,246.185 268.802,262.069 269.575,278.026 269.459,298.011 267.991,321.948 265.15,345.748 262.456,361.503 259.87,373.209 256.631,384.749 254.031,392.306 251.029,399.718 247.627,406.948 243.841,413.974 239.683,420.791 235.166,427.388 230.311,433.746 225.138,439.838 219.627,445.626 213.762,451.053 207.527,456.053 200.919,460.543 193.942,464.436 186.645,467.69 179.105,470.337 171.39,472.42 163.556,473.993 155.642,475.106 147.68,475.8 139.696,476.063 131.711,475.882 123.746,475.268 111.879,473.606 100.136,471.183 80.851,465.932 20.2,445.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "47.0,61.5 76.504,258.122 92.92,339.769 128.3,474.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14.0,61.5 299.9,25.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "55.0,291.7 197.432,273.23 220.862,269.153 244.033,263.698 259.296,259.188 278.05,252.474 307.317,239.98 318.2,234.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "87.7,474.2 390.8,411.901 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "94.7,15.7 110.206,114.198 120.487,221.292 126.6,484.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "69.9,85.3 320.7,75.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.1,224.6 320.7,202.801 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "283.3,43.6 268.461,37.391 257.225,33.44 249.544,31.183 241.743,29.315 233.851,27.919 225.921,27.075 217.932,26.845 209.968,27.259 202.027,28.262 194.163,29.706 186.388,31.563 178.734,33.867 171.237,36.633 163.919,39.856 156.802,43.5 146.521,49.626 136.674,56.456 127.251,63.906 118.262,71.878 109.708,80.307 101.638,89.181 94.103,98.502 87.154,108.273 80.817,118.457 73.241,132.541 66.531,147.059 56.368,173.112 42.335,214.85 35.81,237.908 32.319,253.515 30.376,265.352 29.175,277.286 28.833,289.265 29.335,301.243 30.631,313.174 32.673,325.003 35.441,336.692 38.971,348.158 43.304,359.327 46.663,366.577 50.415,373.65 54.547,380.506 59.055,387.115 63.93,393.45 69.166,399.48 74.761,405.183 80.698,410.54 86.939,415.54 93.454,420.178 100.212,424.453 107.187,428.364 118.0,433.555 129.156,437.959 140.58,441.617 152.206,444.568 163.977,446.844 175.859,448.464 187.817,449.445 199.813,449.804 211.823,449.531 223.784,448.57 235.641,446.861 247.355,444.343 258.87,441.02 270.16,436.962 281.198,432.241 295.476,425.048 309.278,416.983 325.953,405.928 338.818,396.427 348.076,388.799 356.862,380.634 362.386,374.851 367.588,368.777 372.414,362.401 376.8,355.715 380.671,348.718 383.943,341.424 386.534,333.858 387.547,329.989 388.355,326.073 388.942,322.12 389.288,318.133 389.369,314.134 389.16,310.143 388.631,306.181 387.755,302.279 386.504,298.485 384.842,294.855 382.763,291.454 380.296,288.312 377.506,285.442 374.471,282.833 371.258,280.461 364.478,276.288 357.329,272.654 346.285,267.939 258.718,239.598 251.252,236.756 247.621,235.121 244.106,233.122 242.576,230.121 246.398,229.105 250.431,229.015 258.426,229.554 274.21,231.77 293.853,235.68 313.255,240.603 328.551,245.348 339.808,249.488 350.828,254.306 357.922,258.002 361.353,260.037 364.662,262.245 367.797,264.691 370.703,267.426 373.294,270.409 375.594,273.657 377.589,277.087 379.33,280.688 380.809,284.311 383.276,291.862 386.04,303.491 388.655,319.194 392.953,362.824 398.2,479.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "82.8,17.7 30.128,439.335 28.2,459.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "274.8,23.2 234.679,259.687 197.652,435.725 186.0,482.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "55.5,272.3 268.8,231.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "140.2,52.7 151.541,159.292 159.599,476.64 159.6,480.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "29.1,64.7 208.1,20.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "44.8,465.8 237.9,480.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "25.3,28.9 145.013,27.439 288.117,34.536 368.0,40.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "269.6,20.1 309.923,115.882 322.228,149.351 326.909,164.461 329.781,176.055 337.84,223.175 341.516,254.835 344.207,298.586 344.413,322.48 343.455,342.377 341.426,362.194 338.356,381.876 335.064,397.469 330.898,412.851 327.098,424.184 324.135,431.58 320.739,438.789 316.835,445.735 312.355,452.321 309.881,455.444 307.244,458.43 304.44,461.26 301.47,463.915 298.335,466.376 295.049,468.624 291.62,470.647 288.063,472.436 284.395,473.986 280.633,475.297 276.798,476.373 272.917,477.201 268.997,477.62 265.062,477.506 261.09,476.883 257.288,475.885 253.576,474.601 246.275,471.39 235.868,465.699 222.536,457.174 193.611,435.959 108.309,364.19 102.0,358.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "74.2,16.7 91.215,322.1 91.483,365.624 90.532,385.444 88.443,405.17 74.2,483.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "317.1,61.8 128.692,139.428 107.126,149.668 93.083,157.266 82.866,163.526 73.046,170.38 66.77,175.322 60.81,180.639 55.31,186.428 52.793,189.53 50.474,192.779 48.388,196.182 46.573,199.739 45.068,203.436 43.899,207.255 43.081,211.16 42.615,215.124 42.499,219.119 42.721,223.103 43.264,227.054 44.104,230.956 45.22,234.79 46.586,238.544 48.177,242.208 49.97,245.739 51.998,249.077 54.266,252.283 59.241,258.396 75.592,275.676 269.5,454.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "161.9,19.5 157.5,480.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20.0,456.9 238.026,455.193 340.7,448.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "44.7,94.8 47.892,335.147 50.885,386.505 52.602,402.1 53.969,410.176 54.955,414.16 56.384,417.73 59.441,418.936 62.054,415.931 63.689,412.295 64.777,408.466 66.147,400.58 74.92,213.127 80.727,157.546 87.317,114.104 91.337,94.567 94.478,83.007 97.051,75.452 100.116,68.077 103.723,60.958 107.908,54.158 110.245,50.916 112.764,47.817 115.482,44.901 118.434,42.204 121.628,39.81 125.077,37.811 128.778,36.318 132.669,35.454 136.652,35.244 140.621,35.65 144.493,36.614 148.209,38.074 151.719,39.97 154.996,42.257 157.999,44.881 160.711,47.811 163.108,51.007 165.196,54.403 167.017,57.955 168.608,61.62 171.234,69.159 174.234,80.755 180.176,112.139 183.967,139.823 185.989,163.693 186.93,195.552 182.4,319.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "188.5,225.7 193.498,173.947 197.492,146.267 202.071,122.728 205.879,107.206 210.53,91.912 214.636,80.645 219.356,69.622 222.903,62.456 226.813,55.483 231.125,48.753 235.889,42.329 241.184,36.344 244.068,33.576 247.133,31.003 250.384,28.679 253.83,26.665 257.479,25.027 261.294,23.848 265.233,23.189 269.225,23.041 273.212,23.364 277.134,24.108 280.971,25.229 284.698,26.685 288.288,28.436 291.736,30.457 295.031,32.723 298.16,35.214 301.11,37.909 303.885,40.785 306.491,43.816 311.229,50.256 315.399,57.074 319.087,64.167 323.876,75.162 327.947,86.441 333.571,105.619 340.107,132.826 343.01,148.549 344.489,160.448 345.231,172.416 345.216,192.401 324.9,483.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "65.4,100.8 33.1,481.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "33.1,64.9 176.866,432.154 183.295,446.763 186.878,453.891 188.84,457.355 190.979,460.706 193.366,463.853 196.179,466.699 199.507,468.836 203.349,469.753 207.252,469.121 210.775,467.274 213.827,464.753 216.528,461.845 218.966,458.701 223.281,451.999 227.071,444.986 233.677,430.485 247.611,393.132 268.242,328.684 273.322,309.63 322.2,18.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "288.1,46.4 269.342,39.416 257.82,35.845 246.232,32.954 238.346,31.47 230.426,30.439 222.463,29.921 214.475,29.953 206.494,30.509 194.607,32.1 186.772,33.691 179.057,35.777 171.506,38.411 164.179,41.614 157.121,45.372 150.349,49.626 143.851,54.289 134.558,61.878 122.837,72.765 108.951,87.153 95.853,102.258 83.529,117.999 72.036,134.366 63.516,147.912 57.643,158.373 52.425,169.176 49.428,176.591 46.908,184.181 44.931,191.924 43.47,199.785 42.048,211.696 40.499,247.652 40.712,291.671 41.942,315.647 43.623,331.538 45.547,343.373 48.146,355.088 52.581,370.452 56.534,381.78 61.071,392.887 66.243,403.712 72.098,414.183 78.671,424.218 83.473,430.616 88.623,436.736 94.13,442.535 100.003,447.966 106.236,452.977 112.818,457.519 119.73,461.542 126.942,464.998 134.413,467.848 142.088,470.099 149.906,471.788 157.819,472.953 165.789,473.626 173.785,473.835 181.773,473.608 193.707,472.546 205.578,470.756 221.259,467.512 236.725,463.426 248.101,459.618 255.523,456.636 262.769,453.25 269.807,449.451 279.987,443.102 292.943,433.722 308.42,421.022 320.239,410.244 331.458,398.872 339.442,389.89 346.93,380.498 353.784,370.669 357.936,363.857 361.721,356.811 366.687,345.89 370.878,334.649 374.391,323.177 378.164,307.632 380.301,295.826 381.779,283.92 382.529,271.947 382.581,263.948 382.213,255.957 381.363,248.004 379.963,240.131 377.943,232.393 375.248,224.864 371.891,217.606 367.927,210.66 363.414,204.057 358.409,197.82 352.963,191.962 347.121,186.499 340.917,181.453 334.379,176.844 327.54,172.698 320.429,169.038 313.079,165.885 305.545,163.197 294.018,159.874 270.561,154.829 254.77,152.287 242.829,151.09 230.843,150.622 218.87,150.888 206.906,151.916 191.122,154.338 171.621,158.579 140.7,167.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "98.4,74.3 104.3,483.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "69.9,233.3 46.712,128.305 43.226,108.731 41.249,92.947 40.499,81.031 40.562,73.077 41.271,65.154 41.932,61.226 42.832,57.349 43.991,53.544 45.429,49.835 47.149,46.243 49.149,42.801 51.426,39.54 53.984,36.488 56.812,33.688 59.9,31.181 63.236,29.01 66.79,27.221 70.525,25.851 74.392,24.921 78.339,24.401 82.317,24.252 86.29,24.432 90.243,24.903 94.159,25.633 98.023,26.594 101.827,27.763 109.242,30.657 116.367,34.209 123.173,38.334 129.653,42.957 135.805,48.01 141.635,53.431 147.15,59.172 154.856,68.292 161.924,77.915 168.417,87.937 176.296,101.768 183.358,116.031 189.603,130.682 195.012,145.65 199.593,160.892 203.365,176.369 206.338,192.013 208.939,211.743 210.127,227.622 210.493,243.539 209.913,259.449 208.762,271.334 206.907,283.131 205.166,290.9 202.886,298.523 201.496,302.257 199.913,305.911 198.114,309.461 196.077,312.877 193.778,316.127 191.204,319.163 188.359,321.944 185.252,324.428 181.907,326.579 178.353,328.368 174.629,329.783 170.792,330.817 166.875,331.486 162.912,331.813 158.934,331.825 154.967,331.551 151.029,331.024 143.258,329.342 135.621,327.032 124.448,322.828 99.171,311.266 77.8,300.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "282.0,73.7 278.094,66.65 273.853,59.863 269.207,53.377 264.082,47.282 261.318,44.419 258.418,41.716 255.321,39.15 252.115,36.823 248.742,34.714 245.193,32.846 241.531,31.269 237.763,29.988 233.907,29.004 229.983,28.308 226.01,27.877 218.029,27.678 210.07,28.229 202.199,29.52 194.472,31.507 186.922,34.098 175.929,38.836 165.225,44.229 154.831,50.156 144.772,56.626 135.068,63.647 125.795,71.169 116.921,79.214 108.497,87.748 100.571,96.733 90.786,109.311 77.339,129.154 66.971,146.204 61.321,156.759 57.935,163.988 54.942,171.387 52.412,178.956 50.33,186.662 47.908,198.386 45.192,218.154 43.495,238.059 43.004,254.0 43.288,265.96 44.621,281.834 46.913,297.645 50.862,317.226 56.885,340.393 64.13,363.223 68.326,374.437 73.173,385.383 76.878,392.453 81.033,399.267 85.646,405.78 90.658,411.991 98.786,420.781 107.481,429.011 116.604,436.765 126.18,443.949 132.857,448.324 139.783,452.288 146.965,455.771 154.385,458.708 162.008,461.072 169.791,462.841 177.689,463.987 185.655,464.475 193.633,464.273 201.564,463.388 209.405,461.903 217.133,459.906 228.497,456.14 239.607,451.678 250.465,446.634 261.026,440.993 271.234,434.739 281.034,427.862 290.369,420.366 299.177,412.258 307.385,403.543 314.915,394.237 321.761,384.416 327.966,374.178 335.345,360.023 341.789,345.419 347.28,330.43 351.781,315.111 354.483,303.432 356.586,291.64 358.071,279.774 358.925,267.845 359.15,251.899 358.225,231.949 356.671,216.061 354.751,204.244 352.927,196.473 350.551,188.855 347.532,181.469 343.888,174.37 339.746,167.548 332.866,157.748 312.733,132.971 299.384,118.139 288.143,106.804 279.255,98.782 273.039,93.775 266.551,89.128 259.77,84.919 252.697,81.224 245.379,78.035 237.884,75.292 226.412,71.869 210.86,68.269 191.208,64.854 151.566,60.365 83.851,57.155 75.8,57.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "210.8,358.0 216.08,373.121 220.701,384.1 224.201,391.268 228.079,398.241 232.361,404.952 237.053,411.343 242.198,417.455 250.521,426.011 259.281,434.118 265.385,439.188 271.908,443.844 278.657,447.953 289.243,453.375 303.892,459.579 326.462,467.482 372.6,480.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "109.5,70.7 135.746,393.522 140.516,433.144 142.413,444.988 144.113,452.831 145.39,456.517 148.163,457.359 149.179,453.529 149.461,449.56 149.145,433.597 140.574,329.997 136.061,294.297 133.278,278.591 130.614,266.922 126.158,251.595 68.993,102.381 65.194,91.015 63.077,83.31 61.45,75.49 60.464,67.562 60.258,63.57 60.268,59.574 60.518,55.59 61.04,51.63 61.871,47.718 63.053,43.905 64.632,40.239 66.649,36.792 69.124,33.662 72.034,30.935 75.296,28.629 78.808,26.731 82.497,25.206 86.314,24.015 90.21,23.123 94.153,22.501 98.13,22.12 102.124,21.963 110.107,22.258 118.027,23.292 125.838,24.97 133.509,27.204 141.024,29.912 152.001,34.719 162.624,40.264 172.908,46.417 186.148,55.362 202.065,67.468 214.187,77.876 222.831,86.14 231.055,94.856 238.775,104.022 245.916,113.645 252.397,123.723 256.309,130.69 259.864,137.845 263.033,145.178 265.785,152.679 268.089,160.328 269.909,168.107 271.184,175.994 271.776,183.964 271.757,187.959 271.488,191.943 270.934,195.896 270.057,199.796 268.818,203.593 267.187,207.235 265.151,210.67 262.753,213.861 260.046,216.8 257.086,219.483 253.921,221.916 250.586,224.115 247.113,226.092 243.527,227.858 239.853,229.424 232.29,231.998 224.525,233.871 216.634,235.11 208.674,235.787 200.687,235.976 188.714,235.491 176.803,234.252 149.276,229.454 102.267,219.924 86.441,217.586 78.483,216.841 70.495,216.57 66.488,216.7 62.51,217.091 58.586,217.809 54.768,218.924 51.121,220.537 47.792,222.756 45.057,225.641 43.224,229.167 42.567,233.094 43.115,237.035 44.66,240.691 46.938,243.992 49.613,246.923 52.536,249.621 58.801,254.598 213.95,353.178 236.725,369.292 291.941,415.027 370.0,483.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "327.5,37.2 304.635,29.858 289.233,25.773 277.581,23.302 265.771,21.487 257.798,20.727 249.86,20.379 237.897,20.601 225.979,21.61 214.156,23.392 198.581,26.806 152.649,40.189 122.425,50.419 107.618,56.348 96.781,61.419 89.782,65.246 83.093,69.58 79.912,71.989 76.883,74.587 74.048,77.389 71.453,80.411 69.149,83.667 67.186,87.137 65.58,90.785 64.339,94.574 63.469,98.465 62.971,102.422 62.845,106.407 63.089,110.386 63.702,114.327 64.677,118.192 66.009,121.949 67.674,125.573 69.626,129.051 71.816,132.38 74.207,135.57 79.463,141.573 85.172,147.139 94.289,154.884 107.075,164.414 223.729,241.091 262.384,269.283 281.051,284.233 301.83,302.855 330.171,330.922 340.913,342.714 348.494,351.967 355.529,361.639 362.002,371.698 367.925,382.095 373.311,392.778 378.104,403.74 380.819,411.237 383.0,418.911 383.838,422.81 384.475,426.746 384.886,430.71 385.043,434.695 384.925,438.683 384.522,442.65 383.825,446.575 382.821,450.435 381.498,454.199 379.844,457.825 377.844,461.273 375.491,464.492 372.788,467.421 369.749,469.998 366.418,472.185 362.861,473.991 359.151,475.444 355.332,476.584 351.437,477.448 347.494,478.07 339.547,478.698 331.571,478.655 323.616,478.07 311.776,476.377 296.179,473.038 250.121,460.07 204.795,444.728 142.019,419.243 28.1,361.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "26.1,53.9 208.58,46.085 307.177,36.67 378.2,27.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "239.0,19.1 235.891,397.459 232.0,480.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "315.1,86.4 326.148,120.544 332.433,143.666 336.616,163.126 340.403,186.718 342.093,202.577 342.738,214.515 342.663,230.447 341.308,250.333 337.897,278.057 334.437,297.676 330.756,313.18 326.102,328.43 321.956,339.647 317.234,350.635 311.921,361.348 306.001,371.739 299.472,381.757 292.338,391.354 284.642,400.507 273.681,412.087 259.157,425.737 246.954,436.0 237.337,443.11 230.658,447.463 223.742,451.428 216.579,454.93 209.179,457.891 201.558,460.228 193.755,461.851 189.802,462.369 185.829,462.681 181.844,462.783 173.882,462.386 165.995,461.232 158.244,459.369 150.685,456.837 143.372,453.663 136.354,449.883 129.662,445.553 123.309,440.737 117.302,435.495 111.638,429.885 106.308,423.956 98.909,414.562 92.176,404.679 86.049,394.409 80.476,383.833 75.449,372.989 70.98,361.898 67.081,350.579 62.765,335.23 58.524,315.755 52.996,280.317 49.409,248.672 46.0,33.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "29.5,20.4 80.783,115.422 97.757,151.498 117.453,199.585 126.881,225.939 133.774,248.886 143.069,287.752 147.433,311.32 154.173,374.901 156.773,422.789 157.596,430.732 158.28,434.681 159.28,438.551 160.776,442.253 163.012,445.539 166.358,447.613 170.217,447.017 173.276,444.493 175.659,441.289 177.681,437.832 181.148,430.617 232.114,283.339 289.29,83.802 307.6,26.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "33.2,32.0 92.241,381.855 102.086,428.829 106.167,444.406 108.54,451.701 110.101,455.622 111.827,459.079 114.031,462.249 116.862,464.986 120.111,467.274 123.698,468.993 127.54,470.036 131.505,470.35 135.467,469.958 139.314,468.927 142.971,467.349 146.396,465.307 149.554,462.883 152.448,460.139 155.085,457.154 157.494,453.982 159.707,450.664 163.635,443.727 167.051,436.525 171.526,425.435 176.628,410.346 187.621,367.896 197.336,321.062 201.655,293.517 203.588,273.749 205.6,162.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "195.6,165.4 219.547,327.192 226.352,362.171 230.24,377.503 232.645,385.052 238.36,399.83 241.595,407.102 245.272,414.164 247.35,417.558 249.637,420.805 252.183,423.856 255.04,426.632 258.218,429.011 261.718,430.899 265.458,432.247 269.351,433.059 273.316,433.363 277.294,433.197 281.224,432.605 285.082,431.625 288.834,430.293 292.451,428.642 295.921,426.694 299.234,424.484 302.388,422.06 308.272,416.709 313.683,410.869 321.129,401.538 332.461,385.185 342.826,368.202 354.107,347.152 362.488,329.113 368.394,314.337 374.697,295.466 381.902,268.562 385.274,253.014 387.786,237.309 389.714,217.507 390.774,189.67 390.274,157.821 388.609,133.999 386.664,118.215 383.122,98.642 372.407,56.288 368.0,40.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "32.3,16.1 110.086,90.732 134.776,116.741 150.131,134.878 231.572,248.21 253.487,281.467 261.533,295.138 270.646,312.764 295.81,371.265 324.8,445.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "345.0,43.1 32.3,484.099 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "24.8,15.2 91.547,142.193 134.009,213.88 226.7,353.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "279.9,40.7 211.905,197.534 174.973,272.302 50.3,484.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "z.5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "35.6,24.1 95.526,25.064 131.331,27.615 194.743,35.724 230.137,41.874 280.617,53.877 303.669,60.497 318.799,65.669 329.888,70.227 337.04,73.781 340.487,75.775 343.83,77.949 347.037,80.328 350.065,82.943 352.845,85.819 355.281,88.976 357.254,92.426 358.626,96.181 359.223,100.116 358.959,104.092 357.858,107.907 356.044,111.454 353.729,114.742 351.15,117.769 345.526,123.399 126.836,297.598 87.572,331.559 73.087,345.324 64.792,353.97 59.53,359.997 54.63,366.272 50.179,372.904 48.183,376.362 46.38,379.919 44.797,383.593 43.48,387.369 42.469,391.231 41.8,395.161 41.5,399.14 41.583,403.132 42.066,407.094 42.989,410.976 44.375,414.716 46.225,418.255 48.503,421.532 51.149,424.508 54.106,427.181 57.31,429.557 60.704,431.654 64.243,433.496 67.898,435.112 75.452,437.804 83.12,439.944 94.837,442.482 114.591,445.5 142.416,448.153 158.284,448.869 186.062,448.196 369.3,431.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFont5);
export default __webpack_public_path__ + "static/media/font5.a7dda669e2ff9b99a4672eb5974137e2.svg";
export { ForwardRef as ReactComponent };